import { ProgramEngagementModel } from '@cibo/core'
import { Loading, useOrgUser } from '@cibo/profile'
import { useProgramEngagements } from '@cibo/programs'
import { useParamAsInteger } from '@cibo/ui'
import { GridEventListener } from '@mui/x-data-grid-pro'
import { useEffect, useState } from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { ProgramEngagementPlayer } from '../../../components/ProgramEngagementPlayer'
import { ProgramEngagementsList } from '../../../components/ProgramEngagementsList'
import { useProgramEngagementContext } from '../../../features/ProgramEngagement'
import { ENGAGEMENT_ROUTES } from '../../../navigation/types/engagementRoutes'
import { GrowersRouteParams } from '../../../navigation/types/growersRoutes'

export const GrowersProgramDetail = () => {
  const { programId } = useParams<GrowersRouteParams>()
  const userId = useParamAsInteger('userId')

  const user = useOrgUser(userId)

  const { basePath, program } = useProgramEngagementContext()

  // we auto redirect to the engagement if there is only one
  const [disableRedirect, setDisableRedirect] = useState(false)
  const programEngagements = useProgramEngagements({
    filters: [
      {
        userId: !!userId ? [userId] : undefined,
        programId: !!programId ? [programId] : undefined,
      },
    ],
  })
  const navigate = useNavigate()

  useEffect(() => {
    if (programEngagements.data?.items?.length === 1 && !disableRedirect) {
      navigate(
        generatePath(`${basePath}${ENGAGEMENT_ROUTES.STAGE}`, {
          engagementId: programEngagements.data?.items[0].id,
          stageId: 'apply',
        }),
        { replace: true }
      )
    }
    if (!!programEngagements.data?.items?.length && programEngagements.data?.items?.length > 1) {
      setDisableRedirect(true)
    }
  }, [programEngagements.data?.items?.length])

  const onRowClick: GridEventListener<'rowClick'> = ({ id, row }) => {
    navigate(
      generatePath(`${basePath}${ENGAGEMENT_ROUTES.STAGE}`, {
        engagementId: id as string,
        stageId: (row as ProgramEngagementModel).currentStage?.id ?? 'apply',
      })
    )
  }

  if (programEngagements.isLoading || program.isLoading || user.isLoading) {
    return <Loading />
  }

  if (!programId || !user.data?.userId) {
    return <>NOT FOUND!</>
  }

  // return <ProgramEngagementPlayer />
  return programEngagements.data?.items?.length === 0 ? (
    <ProgramEngagementPlayer />
  ) : (
    <ProgramEngagementsList
      programId={programId}
      userId={user.data?.userId}
      onRowClick={onRowClick}
    />
  )
}
